<app-section>
  <div class="tab-section">
    <app-alert [alert]="alert"></app-alert>
    <app-form-header [title]="'Affiliations recorded'"></app-form-header>
    <div class="usesrs-details">
      <app-table-grid
        [headers]="affiliationsHeaders"
        [data]="affiliations"
        [noRecordTxt]="'No affiliations record found'"
      ></app-table-grid>
    </div>
  </div>
</app-section>
<div class="sticky-btns" *ngIf="showBackCPQPNavigationButton">
  <app-section>
    <div class="sticky-btn-container">
      <app-button
        [name]="'Back to CP/QP Nominations'"
        [type]="'secondary'"
        (btnClick)="onBackToWorkFlow()"
        [textTransformNone]="true"
      >
      </app-button>
    </div>
  </app-section>
</div>
